import { AlchemystStoreType } from '@/types/appStates';

export const tunerOptions: {
  name: string;
  keyword: keyof AlchemystStoreType['chat']['tools'];
}[] = [
  {
    name: 'Prospector',
    keyword: 'researchIcps',
  },
  {
    name: 'Web Search',
    keyword: 'webSearch',
  },
  {
    name: 'Enterprise Search',
    keyword: 'organizationSearch',
  },
  {
    name: 'Deep Research',
    keyword: 'deepResearch',
  },
];
